import { getYjql, updateYjql} from '@/api/promotion'
import moment from 'moment';

export default {
    components: {
    },
    props: {
        showYjqlForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        },
    },
    data () {
        return {
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
            loading: false,
            rules: {},
            baseRules: {},
            title: '',
            data: [],
            repeat_types: [{id:1, name:'仅一次'}, {id:2, name:'每周重复'}],
            repeat_days: [
                {key:'EVERY_DAY', name:'每天', is_single:true},
                {key:'PER_MONDAY', name:'每周一', is_single:false},
                {key:'PER_TUESDAY', name:'每周二', is_single:false},
                {key:'PER_WEDNESDAY', name:'每周三', is_single:false},
                {key:'PER_THURSDAY', name:'每周四', is_single:false},
                {key:'PER_FRIDAY', name:'每周五', is_single:false},
                {key:'PER_SATURDAY', name:'每周六', is_single:false},
                {key:'PER_SUNDAY', name:'每周日', is_single:false},
            ],
        }
    },
    created () {
         this.title = '一键起量设置'
    },
    computed: {
        actType() {
            return this.model.id ? '修改' : '添加'
        }
    },
    mounted () {
        // console.log('进入',this.model, this.advertiser_id)
        if (!this.model.advertiser_id && this.model.promotion_ids) {
            this.generateRules()
        } else {
            this.loading = true
            getYjql(this.model).then(res => {
                this.model.raise_info = res.data.raise_info || [this.createRow()]
                this.generateRules()
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        }
       
    },
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.storeOrUpdate()
            });
        },
        storeOrUpdate() {
            this.loading = true

            const data = {
                advertiser_id:  !this.model.advertiser_id && this.model.promotion_ids ? this.model.adv_id : this.model.advertiser_id,
                promotion_id: this.model.promotion_id,
                raise_info: this.model.raise_info,
                promotion_ids: this.model.promotion_ids,
            }

            updateYjql(data).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success('操作成功')
                    this.$emit('success')
                    this.close()
                } else {
                    this.$message.error(res.message);
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:showYjqlForm', false)
        },
        createRow() {
            return {
                raise_budget: null,
                is_effective_now: false,
                repeat_type: 1,
                appoint_time: {
                    raise_time: null,
                    repeat_day: []
                },
            };
        },
        addRow() {
            this.model.raise_info.push(this.createRow());
            this.generateRules()
        },
        generateRules() {
            // 为每个 row 动态生成规则
            this.model.raise_info.forEach((_, index) => {
              this.$set(this.rules, `raise_info[${index}].raise_budget`, [{ required: true, message: '请填写起量预算', trigger: 'change' }]);
              this.$set(this.rules, `raise_info[${index}].repeat_type`, [{ required: true, message: '请选择重复周期', trigger: 'change' }]);
              this.$set(this.rules, `raise_info[${index}].appoint_time.raise_time`, [{ required: true, message: '请选择起量时间', trigger: 'change' }]);
              this.$set(this.rules, `raise_info[${index}].appoint_time.repeat_day`, [{ required: true, message: '请选择每周重复天', trigger: 'change' }]);
            });
            // 合并基础规则和动态规则
            this.rules = { ...this.baseRules, ...this.rules };
        },
        deleteRow (index) {
            this.model.raise_info.splice(index, 1);
            this.generateRules()
        },
        onSelectDay(index, repeat_day) {
            // console.log('repeat_day', repeat_day);
            const lastItem = repeat_day[repeat_day.length - 1];
            const everyDayIndex = repeat_day.indexOf("EVERY_DAY");
        
            if (lastItem === "EVERY_DAY") {
                // 如果最后一个元素是 "EVERY_DAY"，只保留 "EVERY_DAY"
                this.model.raise_info[index].appoint_time.repeat_day = ["EVERY_DAY"];
            } else if (everyDayIndex !== -1) {
                // 如果包含 "EVERY_DAY" 但不是最后一个元素，移除 "EVERY_DAY"
                repeat_day.splice(everyDayIndex, 1);
                this.model.raise_info[index].appoint_time.repeat_day = [...repeat_day];
            } else {
                // 如果不包含 "EVERY_DAY"，直接同步
                this.model.raise_info[index].appoint_time.repeat_day = [...repeat_day];
            }
        },
        handleDateChange(value, index) {
            if (value) {
                // 当前时间
                const now = moment();
                // 用户选择的时间
                const selectedTime = moment(value);
                
                // 判断用户选择的时间是否和当前时间一致（精确到分钟）
                if (selectedTime.isSame(now, 'minute')) {
                  // 如果时间等于当前时间，增加5分钟
                  this.model.raise_info[index].appoint_time.raise_time = now.add(5, 'minutes');
                }
              }
        },
      
    }
}
